export default "__VITE_ASSET__WOx8kYgu__"